import React, { useState } from "react";
import axios from "axios";
import { LoadingSpinner } from "../../components/auxiliarComponents/auxiliarComponents";
import { motion, AnimatePresence } from "framer-motion";

const FreightCalculator = ({ onShippingCalculated }) => {
  const [cep, setCep] = useState("");
  const [distance, setDistance] = useState(null);
  const [freightValue, setFreightValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLoadingFrete, setIsLoadingFrete] = useState(false);

  const handleCepChange = (e) => {
    const newCep = e.target.value
      .replace(/\D/g, "")
      .slice(0, 8)
      .replace(/^(\d{5})(\d)/, "$1-$2");

    setCep(newCep);
  };

  const calculateFreight = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    setError(null);
    setFreightValue(0);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/external/calculate-freight`,
        {
          cep,
        }
      );
      const freightValue = Number(response.data.freightValue) || 0;
      setDistance(response.data.distance);
      setFreightValue(freightValue);
      onShippingCalculated(freightValue);
    } catch (err) {
      setError(err.response?.data?.message || "Erro ao calcular frete");
      setFreightValue(0);
      onShippingCalculated(0);
    } finally {
      setLoading(false);
      setIsLoadingFrete(false);
    }
  };

  return (
    <div className="flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-xl overflow-hidden p-2 space-y-1">
        <header className="text-center">
          <p className="text-gray-600 mt-2">
            Informe o CEP de destino para calcular o valor
          </p>
        </header>

        <form onSubmit={calculateFreight} className="space-y-4">
          <div>
            <label
              htmlFor="cep"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              CEP de destino
            </label>
            <input
              id="cep"
              type="text"
              value={cep}
              onChange={handleCepChange}
              placeholder="Ex: 01001000"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition"
              required
              maxLength={9}
            />
          </div>

          <button
            type="submit"
            disabled={loading || isLoadingFrete}
            className={`w-full py-2 px-4 rounded-lg font-medium text-white transition ${
              loading || isLoadingFrete
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-green-600 hover:bg-green-700"
            }`}
          >
            {loading || isLoadingFrete ? (
              <LoadingSpinner message="Calculando frete..." small={true} />
            ) : (
              "Calcular Frete"
            )}
          </button>
        </form>

        {error && (
          <div className="p-3 bg-red-50 text-red-700 rounded-lg text-sm">
            {error}
          </div>
        )}

        {distance !== null && (
          <div className="p-4 bg-green-50 rounded-lg space-y-2">
            <div className="flex justify-between">
              <span className="text-gray-700">Distância:</span>
              <span className="font-medium">{distance} km</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-700">Valor do Frete:</span>
              <AnimatePresence mode="wait">
                <motion.span
                  key={freightValue}
                  initial={{ scale: 1.2 }}
                  animate={{ scale: 1 }}
                  exit={{ scale: 0.8, opacity: 0 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <span className="font-medium text-green-600">
                    R$ {Number(freightValue).toFixed(2)}
                  </span>
                </motion.span>
              </AnimatePresence>
            </div>
          </div>
        )}

        <footer className="text-center text-xs text-gray-500 mt-6">
          <p className="text-red-500 text-sm">🚨Cálculo estimado</p>
          <p className="mb-2">
            O valor do frete é calculado com base na distância informada pelo
            CEP de destino.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default FreightCalculator;
